import { HeaderComponent, BodyComponent, TableComponent, ActionComponent, CreateButton, RefreshButton, FilterComponent, ImportButton, PaginationComponent } from '@comps/components';
import { makeRequest, formatCompleteDataTime, notify, removeById, replaceById } from '@utils/helpers';
import { useState, useEffect } from 'react';
import { getAllGroups, deleteJobTitleReq, getFilterReq, deleteDataReq } from "./requests";
import CreateGroup from './components/CreateGroup';
import ViewGroup from './components/ViewGroup';
import { UserOutlined } from '@ant-design/icons';
import { message, Tooltip } from "antd"

// ==================================
//   Page Breadcrumbs Start
// ==================================
const pageConfig = {
  headers: {
    title: 'groups',
    createEntity: 'Group',
    breadcrumb: [
      {
        name: 'groups',
        path: '/organization/Route'
      }
    ]
  }
}

// ==================================
//   Page Breadcrumbs End
// ==================================

// ==================================
//   Use States Start
// ==================================

const Indexgroups = (props) => {
  const totalRecords = 0;
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);
  const [filters, setFilters] = useState();
  //start pagination states
  const [currentPage, setCurrentPage] = useState(1)
  const [payitems, setPayitems] = useState({});
  const [pagination, setPagination] = useState({
    "total": 14,
    "count": 10,
    "per_page": 10,
    "current_page": 1,
    "total_pages": 2,
    "links": {}
  });

  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================
  const columns = [
    {
      key: 'code',
      title: 'Code',
      dataIndex: 'code',
      sorter: true,
    },
    {
      key: 'name',
      title: 'Group Name',
      dataIndex: 'name',
      sorter: true,
    },
    {
      key: 'actions',
      title: 'Actions',
      render: (record) => <ActionComponent modkey={ props.modkey } each={ record } onEdit={ onEdit } onView={ onView } onDelete={ onDelete }>
        <Tooltip title='Add Employees'>
          <UserOutlined className="icon-style da-text-color-info-1 ms-3" style={ { color: "#1677ff" } } onClick={ () => onAddEmployee(record) } />
        </Tooltip>
      </ActionComponent>
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [filters, currentPage]);
  const getAllData = () => {
    const payload = {
      page: currentPage,
      filters: filters
    }
    makeRequest(setLoader, getAllGroups, payload, onSuccess, null);
  }

  const onSuccess = (response) => {
    setPagination(response.groups);
    setDataSource(response.groups.data);

  }

  const onEdit = (record) => {
    setChildComponent(
      <ViewGroup onCreated={ onCreated } record={ record } disabled={ false } addEmployees={ true } />
    );
  }

  const onView = (record) => {
    setChildComponent(<ViewGroup onCreated={ onCreated } record={ record } />);
  }
  const onAddEmployee = (record) => {
    setChildComponent(
      <ViewGroup onCreated={ onCreated } record={ record } disabled={ true } addEmployees={ true } />
    );
  };
  // Create component modal
  const onCreate = () => {
    setChildComponent(<CreateGroup onCreated={ onCreated } onCompleted={ onCreated } onSuccess={ onSuccess } />);
  }

  const onCreated = (data) => {
    if (data) {
      getAllData()
    }

    setChildComponent(null);
  }
  const onDelete = (record) => {
    makeRequest(setLoader, deleteDataReq, record.id, onDeleted, onError);
  };
  const onDeleted = (res) => {
    onSuccess(res)
    getAllData()
    message.info("Deleted")
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || 'id',
      sortType: sorter.order === 'ascend' ? 'asc' : 'desc',
    };
    setPagination(payload);
  }

  // ==================================
  //   Component JSX Start
  // ==================================

  return (
    <>
      { childComponent }
      <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>
        <RefreshButton onClick={ getAllData } /> <CreateButton onClick={ onCreate } />
      </HeaderComponent>
      <BodyComponent>

        <TableComponent loader={ loader } columns={ columns } dataSource={ dataSource } pagination={ {
          ...pagination,
          total: totalRecords
        } } onChange={ handleTableChange } />
      </BodyComponent>
      <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
    </>
  );

}

// ==================================
//   Component JSX End
// ==================================

export default Indexgroups
